import { useRef } from 'react';
import React from 'react'
import '../../../Style/online-train/form.css'
import { useState } from 'react'
import FlashAddFun from "../Add_sub/Function/FlashAddFun";

const random = (min, max) => {
    return (Math.floor(Math.random()
        * (max - min + 1)) + min);
}
const FlashAdd = () => {

    const getswitch = (digit1) => {

        switch (digit1) {
            case '1':
                return random(1, 9)
                break;
            case '2':
                return random(10, 99)
                break;
            case '3':
                return random(100, 999)
                break;
            case '4':
                return random(1000, 9999)
                break;
            default:
                break;
        }
    }
    const [digit1, setdigit1] = React.useState();
    const [row, setrow] = React.useState();
    const [ques, setques] = React.useState();
    const [file, setfile] = React.useState();
    const [sub, setsub] = React.useState(0);
    const [zig, setzig] = React.useState(0);
    const [storfl, setstorfl] = React.useState("flash");
    const [dic, setdic] = React.useState(0);
    const [btn, setbtn] = React.useState(0);
    const [dicrange, setdicrange] = React.useState(1000);
    const [mat, setmat] = useState([])
    const [refrsh, setrefrsh] = useState(0)
    let lowval = 1;

    const refpdf = useRef();

    const getmat = (ques, row) => {
        let temp = []
        let ele;
        for (let j = 0; j < ques; j++) {
            for (let i = 0; i < row; i++) {
                ele = getswitch(digit1)
                temp.push(ele)
            }
            mat.push(temp)
            temp = []
        }
    }


    function cal(event) {
        event.preventDefault();
        if (refrsh) {
            window.location.reload()
        }
        if (!sub && !zig) {
            getmat(ques, row)
        }

        let min;
        let max;

        switch (digit1) {
            case '1':
                min = 1
                max = 9
                break;
            case '2':
                min = 10
                max = 99
                break;
            case '3':
                min = 100
                max = 999
                break;
            case '4':
                min = 1000
                max = 9999
                break;
            default:
                break;
        }
        if (zig && !sub) {
            let temp = []
            let ele;
            for (let j = 0; j < ques; j++) {
                for (let i = 0; i < row; i++) {
                    ele = random(1, max)
                    if (random(1, 9) == 2 || random(1, 9) == 6) {
                        ele = random(1, 50)
                    }
                    temp.push(ele)
                }
                mat.push(temp)
                temp = []
            }
        }
        if (!zig && sub) {
            for (let i = 0; i < ques; i++) {
                let temo = [];
                let total = 0;
                for (let j = 0; j < row; j++) {
                    let ele = 0;
                    if (total == 0) {
                        ele = random(min, max)
                    } else {
                        ele = random(-min, -max);
                        if (Math.sign(ele + total) == -1) {
                            while (Math.sign(ele + total) <= -1) {
                                ele = random(min, max)
                            }
                        }

                    }
                    total = ele + total
                    temo.push(ele)
                }
                mat.push(temo)
                temo = []
            }

        }
        if (sub && zig) {
            for (let i = 0; i < ques; i++) {
                let temo = [];
                let total = 0;
                for (let j = 0; j < row; j++) {
                    let ele = 0;
                    if (total == 0) {
                        ele = random(min, max)
                    } else {
                        ele = random(-max, max);
                        if (Math.sign(ele + total) == -1) {
                            while (Math.sign(ele + total) <= -1) {
                                ele = random(-max, max)
                            }
                        }

                    }
                    total = ele + total
                    temo.push(ele)
                }
                mat.push(temo)
                temo = []
            }

        }

        if (mat.length != 0) {
            setbtn(1)
        }
    }

    let props = {
        ques: ques,
        row: row,
        mat: mat,
        file: file,
        dic: dic,
        dicrange: dicrange,
    }


    const targetRef = useRef();

    return (
        <div>
            <div className='bg'>
                <div className='main'>
                    <form onSubmit={cal} className='main-form'>
          <h2 className='form-name'>Add<span className='underline'>ition/Subract</span>ion (Flash)</h2>

                        <label htmlFor="digit">Number of Digit</label>
                        <input type="number" className='box' max="4" name="name" id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />

                        <label htmlFor="row">Number of Rows</label>
                        <input type="number" name="email" className='box' id="row" placeholder="3" required onChange={(e) => { setrow(e.target.value) }} />

                        <div className='check' >
                            <label htmlFor="sub">Include Subraction  --</label>
                            <input type="checkbox" name="reference" id="sub" onClick={() => { return sub ? setsub(false) : setsub(true) }} />
                        </div>
                        <div className='check'>
                            <label htmlFor="zig">Zig-zag? -- </label>
                            <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return zig ? setzig(false) : setzig(true) }} />
                        </div>
                        <div className='check check-dic'>

                            <label htmlFor="dictation">Speed? -- </label>
                            <input type="checkbox" name="zig-zag" id="zig-zag" checked />

                            <div className={"show-range"}>
                                <div className='set-dic'>
                                    <div>
                                        <input type="radio" id="html" name="fav_language" onClick={() => { setdicrange(1800) }} />
                                        <label id='slow'>Slow</label><br />
                                    </div>
                                    <div>
                                        <input type="radio" id="css" name="fav_language" value="CSS" onClick={() => { setdicrange(1300) }} />
                                        <label id='Medium'>Medium</label><br />
                                    </div>
                                    <div>
                                        <input type="radio" id="javascript" name="fav_language" value="JavaScript" onClick={() => { setdicrange(1000) }} />
                                        <label id='Fast'>Fast</label>
                                    </div>
                                    <div>
                                        <input type="radio" id="javascript" name="fav_language" value="JavaScript" onClick={() => { setdicrange(900) }} />
                                        <label id='Super_Fast'>Super Fast</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                        </div>
                        <label htmlFor='ques'>No Of Questions</label>
                        <input type="number" name="ques" id="ques" max={100} placeholder="10" className='box' required onChange={(e) => { setques(e.target.value) }} />

                        <label htmlFor='ques'>File name</label>
                        <input type="text" name="file" id="file" className='box' placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />


                        <div className='submit'>
                            <input className='bt-purple' type="submit" id='reset' value="Finish" onSubmit={() => { }} />
                            <input className='bt-purple' type="reset" id='reset' value="Refresh" onClick={() => { window.location.reload() }} />
                        </div>
                    </form>
                </div>
                <div  className={btn ?"show-FlashFun":"hide-FLashFun"}>
                        <div className={btn ? "flash-pop-bg" : "flash-no-pop-bg"}></div>
                        <div className={btn ? "flash-pop-up" : "flash-no-pop-up"}>
                            <button className='X-btn' onClick={() => { setbtn(0) }}>X</button>
                            <FlashAddFun {...{ mat, ques, row, file, dicrange,storfl }} />
                        </div>
                </div>
            </div>
        </div>

    )
}
export default FlashAdd